import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const LINKS = [
  ['Why Padel', '#why-padel'],
  ['Locations', '#locations'],
  ['Gallery', '#gallery'],
  ['Coaching', '#coaching'],
  ['Franchise', '#franchise'],
  ['FAQ', '#faq'],
];

export const NlHeader = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    fn();
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <header
      data-testid="nl-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-300 ${scrolled || open ? 'nl-glass border-b border-white/10' : 'border-b border-transparent'}`}
    >
      <div className={`nl-container flex items-center justify-between transition-[padding] duration-300 ${scrolled ? 'py-3' : 'py-5'}`}>
        <a href="#top" data-testid="nl-nav-logo" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_ace-padel/artifacts/l64uaepk_Full%20lockup_3%404x-8.png"
            alt="space# padel"
            className="h-9 md:h-10 w-auto invert"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`nl-nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
              className="text-[0.78rem] font-semibold tracking-[0.14em] uppercase text-slate-300 hover:text-amber-400 transition-colors"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button onClick={onBook} data-testid="nl-header-book-btn" className="nl-btn nl-btn-primary nl-btn-sm hidden sm:inline-flex">
            Book a Court
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nl-mobile-menu-toggle"
            aria-label="Toggle menu"
            className="lg:hidden w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nl-mobile-menu" className="lg:hidden nl-glass border-t border-white/10">
          <div className="nl-container py-6 flex flex-col gap-1">
            {LINKS.map(([label, href]) => (
              <a
                key={href}
                href={href}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-semibold tracking-wide uppercase text-slate-200 hover:text-amber-400 border-b border-white/5"
              >
                {label}
              </a>
            ))}
            <button onClick={() => { setOpen(false); onBook(); }} data-testid="nl-mobile-book-btn" className="nl-btn nl-btn-primary mt-4">
              Book a Court
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
